export const inverseePendulumController = {
  id: 1,
  title: "Inverse Pendulum Controller",
  activityId: 3,
  startDate: '2020-12-01',
  endDate: '2021-01-31',
  description: "Developed a Java-based Fuzzy-Controller for pendulum stabilization, optimizing control systems in a simulation environment over 2 months.",
  categorizedSkills: {
    profession: [
      { name: "Software Development", weight: 1 },
      { name: "Fuzzy Logic", weight: 0.9 },
      { name: "Control Systems", weight: 0.8 }
    ],
    language: [
      { name: "Java", weight: 1 }
    ],
    tools: [],
    lead: []
  },
  goal: "Implement and optimize a Fuzzy-Controller for pendulum stabilization with Java.",
  detailsFile: "inverse-pendulum-controller.md", // Reference to markdown file
  metrics: [],
  role: "Student Software Engineer",
  teamSize: "1",
  git: "not available",
  link: "not available",
  isProfessional: true,
  isVisible: true
};
